import { useState, useContext } from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import { GroupContext } from "../services/contexts/GroupContext";
import MultiSelect from "../components/common/MultiSelect";
import { Link } from "react-router-dom";
import API from "../services/api";
import Confirmation from "./Confirmation";
import folderpng from "../imgs/Folder.png";
import CustomButton from "./common/CustomButton";
import classes from "./FolderItem.module.css";
import toast from "react-hot-toast";

function FolderItem(props) {
  const { 
    folder, 
    role, 
    getFoldersByParent, 
    isChecked, 
    onCheckChange,
  } = props;
  
  const { globalData } = useContext(GroupContext);
  const [showEditFolderModal, setShowEditFolderModal] = useState(false);
  const [selectedFolder, setSelectedFolder] = useState({
    folder_name: folder.folder_name || "",
    selectedGroups: folder.groups || [],
    applyToAll: false,
    applyOption: null,
  });

  const handleEditFolderShow = () => setShowEditFolderModal(true);
  const handleEditFolderClose = (resetTodefault = true) => {
    if (resetTodefault) {
      setSelectedFolder({
        folder_name: folder.folder_name || "",
        selectedGroups: folder.groups || [],
        applyToAll: false,
        applyOption: null,
      });
    } else {
      setSelectedFolder((prev) => ({
        ...prev,
        applyToAll: false,
        applyOption: null,
      }));
    }
    setShowEditFolderModal(false);
  };

  const updateFolder = (itemID, name) => {
    API.put(`/updateFolder`, {
      id: itemID,
      folder_name: name,
      original_name: folder.folder_name,
      path: folder.path,
      parent_id: folder.parent_id,
      group_ids: selectedFolder.selectedGroups.map((group) => group.group_id),
      applyOption: selectedFolder.applyToAll
        ? selectedFolder.applyOption
        : null,
    })
      .then((response) => {
        alert(response.data.msg);
        getFoldersByParent();
        handleEditFolderClose(false);
      })
      .catch((e) => {
        alert(e.response.data.msg);
      });
  };
  const saveChanges = () => {
    updateFolder(folder.id, selectedFolder.folder_name);
  };

  return (
    <>
      {role === 1 && (
        <td>
          <div className={classes.checkbox_wrapper}>
            <input
              checked={isChecked}
              type="checkbox"
              onChange={onCheckChange}
            />
          </div>
        </td>
      )}
      <td className={classes.folder_td_cell}>
        <Link
          className={classes.folder_box}
          style={{ textDecoration: "none", color: "inherit" }}
          to={`/${folder.path.split("/").slice(1).join("/")}/${
            folder.folder_name
          }`}
          state={{
            parentPath: folder.path,
            currentFolderId: folder.id,
            currentName: folder.folder_name,
          }}
        >
          <img src={folderpng} alt="folder" className={classes.folder_icon} />
          <div className={classes.folder_link}>{folder.folder_name}</div>
        </Link>
      </td>

      <td>{/* Uploaded Date (Empty for folders) */}</td>
      <td>
        {folder.created_date
          ? new Date(folder.created_date).toLocaleDateString()
          : ""}
      </td>
      <td>
        {folder.last_modify_date
          ? new Date(
              folder.last_modify_date.replace("Z", "")
            ).toLocaleDateString()
          : ""}
      </td>

      {role === 1 && (
        <td>
          <div className={classes.action_button_wrapper}>
            <CustomButton
              variant="outline-primary"
              onClick={handleEditFolderShow}
              className={classes.action_button}
            >
              Edit
            </CustomButton>
            <Confirmation
              content={`Please confirm ${
                folder.inactive === 1 ? "activate" : "deactivate"
              } this folder ?`}
              Children={
                <CustomButton
                  variant={
                    folder.inactive === 1 ? "outline-success" : "outline-danger"
                  }
                  className={classes.action_button}
                >
                  {folder.inactive === 0 ? "Deactivate" : "Activate"}
                </CustomButton>
              }
              onConfirm={() => {
                API.put("inactivateFolders", {
                  folder_id: folder.id,
                  folder_name: folder.folder_name,
                  folder_path: folder.path,
                  inactive: folder.inactive === 0 ? 1 : 0,
                })
                  .then(() => {
                    getFoldersByParent();
                  })
                  .catch(() => {
                    alert("Something goes wrong! Please try again.");
                  });
              }}
            />
          </div>
        </td>
      )}
      <Modal
        show={showEditFolderModal}
        onHide={handleEditFolderClose}
        backdrop="static"
      >
        <Modal.Header className="_g-modal-header_">
          <div className="_g-close-button-anchor_">
            <div className="_g-close-button_" onClick={handleEditFolderClose}>
              &#x2715;
            </div>
          </div>
          Edit Folder Name
        </Modal.Header>
        <Modal.Body className="_g-modal-body_">
          <label className={classes.label}>
            Folder Name <span style={{ color: "#EF2626" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            placeholder="New Folder Name"
            value={selectedFolder.folder_name}
            onChange={(e) => {
              setSelectedFolder((prev) => ({
                ...prev,
                folder_name: e.target.value,
              }));
              if (e.target.value.length === 55) {
                toast.error(
                  "Folder name cant not be longer than 55 characters"
                );
              }
            }}
            maxLength={55}
          />

          <div className={classes.group_select}>
            <MultiSelect
              label="Assign group"
              options={globalData.allGroups}
              selected={selectedFolder.selectedGroups}
              onChange={(newGroups) => {
                setSelectedFolder((prev) => ({
                  ...prev,
                  selectedGroups: newGroups,
                }));
              }}
              placeholder="Please Select"
            />
          </div>

          <div className={classes.applyToAll}>
            <input
              type="checkbox"
              checked={selectedFolder.applyToAll}
              onChange={() => {
                setSelectedFolder((prev) => ({
                  ...prev,
                  applyToAll: !prev.applyToAll,
                  applyOption: !prev.applyToAll ? "changesOnly" : null,
                }));
              }}
            />
            <span>Apply to this folder, subfolders and files</span>
          </div>
          {selectedFolder.applyToAll && (
            <div
              className={classes.applytoAllRadios}
              style={{ display: "flex", gap: "20px", padding: "20px" }}
            >
              <label className={classes.label}>
                <input
                  type="radio"
                  name="applyAll"
                  value="changesOnly"
                  checked={selectedFolder.applyOption === "changesOnly"}
                  onChange={(e) =>
                    setSelectedFolder((prev) => ({
                      ...prev,
                      applyOption: e.target.value,
                    }))
                  }
                />
                <span>Apply changes only</span>
              </label>
              <label className={classes.label}>
                <input
                  type="radio"
                  name="applyAll"
                  value="overwriteAll"
                  checked={selectedFolder.applyOption === "overwriteAll"}
                  onChange={(e) =>
                    setSelectedFolder((prev) => ({
                      ...prev,
                      applyOption: e.target.value,
                    }))
                  }
                />
                <span>Overwrite all categories to content</span>
              </label>
            </div>
          )}
          <div className="_g-modal-button-wrapper_">
            <CustomButton
              variant="outline-secondary"
              onClick={handleEditFolderClose}
            >
              Close
            </CustomButton>
            <CustomButton
              variant="primary"
              onClick={saveChanges}
              disabled={!dataIsDirty(folder, selectedFolder)}
            >
              Save
            </CustomButton>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

FolderItem.propTypes = {
  folder: PropTypes.object.isRequired,
  role: PropTypes.number.isRequired,
  getFoldersByParent: PropTypes.func.isRequired,
  isChecked: PropTypes.bool,
  onCheckChange: PropTypes.func,
};

const dataIsDirty = (originalFolder, newFolder) => {
  const isDirty =
    originalFolder.folder_name !== newFolder.folder_name || //Check foldername
    (newFolder.applyToAll !== false && newFolder.applyOption !== null) || //Check apply options
    JSON.stringify(newFolder.selectedGroups) !== JSON.stringify(originalFolder.groups); //Check groups
  return isDirty;
};

export default FolderItem;
